module.exports = __webpack_public_path__ + "olm.219048b.wasm";